<template>
    <div class="regular fullBg">
        <div class="rightWeekData ">
            <div class="headP">
                <p class="img"><img
                        :src="infoMesData?infoMesData.avatar:require('@/assets/img/updateImg/playerHead.png')" alt="">
                </p>
                <p class="name">
                    <span class="zh">{{infoMesData?infoMesData.name:''}}</span>
                    <span class="en">{{infoMesData?infoMesData.nameEn:''}}</span>
                </p>
                <p class="position">
                    <img src="../assets/img/playerImg/staffPosition.svg" alt="">
                    <i>{{infoMesData && infoMesData.title ?titMsg(infoMesData.title):''}}</i>
                </p>
                <p class="playerMsg">
                    <span class="star">{{barDate}}</span>
                </p>

            </div>
            <div class="barTit">
                <div class="time_box" v-if="playersReportList.length">
                    <img @click="changeDay('-')" src="@/assets/img/common/toLeft-icon.svg" class="btn" alt />
                    <span class="today">{{this.dateBar.date}}</span>
                    <img @click="changeDay('+')" src="@/assets/img/common/toRight-icon.svg" class="btn" alt />
                </div>
                <div v-for="item in colorObj.slice()"  v-if="playersReportList.length" style="display: inline-block">
                    <span class="titLab">{{item.name}}</span>
                    <span class="titCol" :style="`background: linear-gradient(180deg, ${item.start} 0%, ${item.end} 100%);`"></span>
                </div>
            </div>
            <div id="weekBar" style="height: calc(100% - 11vw);  width: 90%;"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "assessmentReportDetail",
        props: {
            // trainingReportId: String
        },
        data() {
            return {
                trainingReportId: this.$route.params.id,//球员id
                seasonId: this.$route.params.seasonId,//赛季id
                // seasonId: '5f2ba38c923b9753b315f0b9',//赛季id
                // trainingReportId: '5f09beab2bbde45f19a0558d',//球员id
                allTit: [],//
                infoMesData: {},//初始化的数据
                playersReportList: [],//球员获取评估项

                workDiagram: {},//雷达图各项数据
                dateBar: {},//柱状图各项数据
                barLin: 55,//柱状图显示个数
                barDate: '',//柱状图时间

                timeInfo: null,//定时器--首次加载
                timer: null,//定时器--间隔加载

                otherPlayer: ['doctor', 'interpretor', 'teamManager'],//队医，翻译，梯队经理评估
                barIndex: 0,
                colorObj: [
                    {
                        name: '',
                        start: "#FFB23E",
                        end: "#FFD02B",
                        key: ""
                    },
                    {
                        name: '',
                        start: "#AD6BEA",
                        end: "#C186F2",
                        key: ""
                    },
                    {
                        name: '',
                        start: "#2979FF",
                        end: "#42A5F5",
                        key: ""
                    }, {
                        name: '',
                        start: "#34C955",
                        end: "#85C934",
                        key: ""
                    }, {
                        name: '',
                        start: "#E65045",
                        end: "#E98680",
                        key: ""
                    },
                    {
                        name: '',
                        start: "#979797",
                        end: "#B4B4BB",
                        key: ""
                    },
                ],


                barColorOther: [ {
                    name: '职位核心价值',
                    start: "#2979FF",
                    end: "#42A5F5",
                },
                    {
                        name: '岗位实践情况',
                        start: "#AD6BEA",
                        end: "#C186F2",
                    }, ],
            }
        },
        mounted() {
            this.infoFn();
            this.tit();
        },
        watch: {
            barIndex: {
                handler(val) {
                    this.weekBarData(this.playersReportList[val]);
                }
            }
        },
        methods: {
            tit(){
                this.$server.commonDataTit({key:'title'})
                    .then((res)=>{
                        this.allTit=res.data;
                    })
            },
            titMsg(str){
                console.log(str)
                for (let i=0;i<this.allTit.length;i++){
                    if(this.allTit[i].key==str){
                        return this.allTit[i].value
                    }
                }
            },
            //初始化数据
            infoFn() {
                let data = {
                    id: this.trainingReportId,//球员id
                    info: 'staffPersonal'
                }
                this.$server.getUserMsg(data).then((res) => {
                    this.infoMesData = res.data;
                    // console.log(this.infoMesData)
                    //柱状图
                    data = {
                        playerId: this.trainingReportId,//球员id
                        start: new Date().getFullYear()+'/01/01',
                        end: this.$global.formatDate(new Date(), 'yyyy/MM/dd', true),
                    }
                    this.$server.getPlayersReportWeekAll(data).then((res) => {
                        this.playersReportList = res.data;
                        // console.log(res.data,'res.data');
                        this.barIndex = 0;
                        this.weekBarData(res.data[this.barIndex]);
                    });
                    this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + this.infoMesData.name + this.$global.randomFn(this.$aiJson.playVoice.reportDetail)), true, false)
                })
            },
            // 切换日期
            changeDay(flag){
                if(flag === '-' && this.barIndex > 0) {
                    this.barIndex--
                }
                if(flag === '+' && this.barIndex < this.playersReportList.length){
                    this.barIndex++
                }
            },
            //柱状图
            weekBarData(data) {
                let barWidth = 13;//柱状图默认宽度
                console.log(data);
                this.dateBar = this.serializationList(data);
                let barSeriesData = this.dateBar.showDataAll;
                let thisBarDataX = [];//柱状图个数
                let thisBarData = [];//柱状图数据
                for (let i = 0; i < this.barLin; i++) {
                    thisBarDataX.push(i);
                    thisBarData.push(barSeriesData[i].data)
                }
                // 指定图表的配置项和数据
                let myChart = this.$echarts.init(document.getElementById('weekBar'));

                myChart.setOption({
                    grid: {
                        x: 40,
                        // y: 10,
                        right: 0,
                        top: '10%',
                        bottom: '5%',
                        borderWidth: 1
                    },
                    //  ------  X轴 ------
                    xAxis: {
                        show: false,  // 是否显示
                        nameGap: 15, // 坐标轴名称与轴线之间的距离
                        nameRotate: 0,  // 坐标轴名字旋转
                        axisLine: {       // 坐标轴 轴线
                            show: true,  // 是否显示
                            // ------   线 ---------
                            lineStyle: {
                                color: '#616162',
                                width: 1,
                                type: 'solid'
                            }
                        },
                        axisTick: {    // 坐标轴 刻度
                            show: false,  // 是否显示
                        },
                        type: 'category',
                        data: thisBarDataX
                    },
                    //   ------   y轴  ----------
                    yAxis: {
                        show: false,  // 是否显示
                        nameTextStyle: {    // 坐标轴名称样式
                            color: '#fff',
                            padding: [5, 0, 0, 5]  // 坐标轴名称相对位置
                        },
                        nameGap: 15, // 坐标轴名称与轴线之间的距离

                        axisLine: {    // 坐标轴 轴线
                            show: true,  // 是否显示
                            // ----- 线 -------
                            lineStyle: {
                                color: '#616162',
                                width: 1,
                                type: 'solid'
                            }
                        },
                        axisTick: {      // 坐标轴的刻度
                            show: true,    // 是否显示
                            inside: true,  // 是否朝内
                            length: 3,      // 长度
                            lineStyle: {
                                color: '#616162',  // 默认取轴线的颜色
                                width: 1,
                                type: 'solid'
                            }
                        },
                        axisLabel: {      // 坐标轴的标签
                            show: true,    // 是否显示
                            inside: false,  // 是否朝内
                            rotate: 0,     // 旋转角度
                            margin: 8,     // 刻度标签与轴线之间的距离
                            color: '#fff',  // 默认轴线的颜色
                        },
                        splitLine: {    // gird 区域中的分割线
                            show: true,   // 是否显示
                            lineStyle: {
                                color: '#666',
                                width: 1,
                                type: 'solid'
                            }
                        },
                    },
                    //  -------   内容数据 -------
                    series: [
                        {
                            type: 'bar',      // 类型
                            label: {
                                show: true,
                                position: 'top',
                                distance: 15,
                                align: 'left',
                                verticalAlign: 'middle',
                                rotate: 90,
                                formatter: (ind) => {
                                    let title = barSeriesData[ind.dataIndex].evaluationTemplateItem;
                                    return title ? title.itemName : ''
                                },
                                fontSize: 12,
                                color: 'rgba(255,255,255,.35)',
                            },
                            itemStyle: {    // 图形的形状
                                normal: {
                                    //柱形图圆角，初始化效果
                                    barBorderRadius: [3, 3, 0, 0],
                                    color: (params) => {
                                        return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 1,
                                            color: barSeriesData[params.dataIndex].start
                                        },
                                            {
                                                offset: 0,
                                                color: barSeriesData[params.dataIndex].end
                                            }])
                                    }
                                }
                            },
                            barWidth: barWidth,  // 柱形的宽度
                            barGap: '10%',
                            // barCategoryGap: '20%',  // 柱形的间距

                            data: thisBarData,
                            markLine: {
                                symbol: ['none', 'none'],//去掉箭头
                                lineStyle: {
                                    type: 'dotted',
                                    color: 'rgba(207, 212, 217, .36)'
                                },
                                label: {
                                    // position: 'insideStartTop'
                                },
                                data: [
                                    {type: 'average', name: '平均值'}
                                ]
                            },//平均线
                            animationDelay:  (idx) => {
                                return idx * this.barLin*2;
                            }
                        }
                    ]
                });

            },
            //数据分类
            serializationList(list) {
                let data = list.evaluationDataMap;
                // console.log(data);
                let label = Object.keys(data);
                // console.log(label);
                let index = 0;
                label.map((item) => {
                    if(this.colorObj[index] && item !== 'Other') {
                        this.colorObj[index].key = item;
                        this.colorObj[index].name = item;
                        index++;
                    }
                })

                let dataAll = [];
                let showDataAll = [];
                this.colorObj.map(item => {
                    if (data[item.key]) {
                        data[item.key].map(j => {
                            dataAll.push({
                                ...j,
                                ...item,
                            })
                        })
                    }
                })
                // console.log(this.colorObj)

                // console.log(dataAll)

                if (dataAll.length < this.barLin) {
                    let lengthNum = Math.ceil(this.barLin/dataAll.length);
                    console.log(lengthNum)
                    console.log(dataAll.length)
                    for (let i = 0; i < lengthNum; i++) {
                        showDataAll.push(...dataAll)
                    }
                }else {
                    showDataAll = dataAll
                }

                return {
                    ...list,
                    showDataAll,
                }
            },
            //问题分类
            positionScreen(data) {
                let map = {}
                for (let i = 0; i < data.length; i++) {
                    map[data[i].key] = data[i]
                }
                // console.log(map);
                return map
            },
        },
        destroyed() {
            clearInterval(this.timer);
            clearInterval(this.timeInfo);
        }
    }
</script>

<style scoped lang="less">
    .fullBg {
        background-image: url("../assets/img/updateImg/bg3.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .rightWeekData {
        /*padding-left: 3vw;*/
        box-sizing: border-box;
        float: left;
        position: relative;
        width: 75%;
        height: calc(100% - 8vw);
        display: inline-block;
        margin-bottom: 3vw;
        padding: 5vw 8vw 0 5vw;
        color: #fff;
    }

    .time_box{
        position: absolute;
        right: 0;
        top: -9vw;
        display: flex;
        align-items: center;
        .btn{
            width: 2vw;
            height: 2vw;
        }
        .today{
            margin: 0 1vw;
            font-family: PingFang;
            font-size: 24px;
            color: var(--fff8);
        }
    }

    .barTit {
        /*position: absolute;*/
        /*top: 14vw;*/
        /*right: 5vw;*/
        padding-bottom: 1vw;
        margin-right: 1vw;
        margin-top: 3vw;
        font-size: 22px;
        position: relative;

        span {
            float: right;
        }

        .titCol {
            width: 20px;
            height: 20px;
            display: inline-block;
        }

        .titColXingGe {
            background: #F3C74E;
        }

        .titColJiShu {
            background: #71ABFB;
        }

        .titColZhanShu {
            background: #4BCC6E;
        }

        .titLab {
            margin-top: -.3vw;
            display: inline-block;
            font-family: PingFang;
            color: #fff;
            padding-left: .5vw;
            padding-right: 1.5vw;
            max-width: 9vw;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }

    .message {
        position: absolute;
        right: 14%;
        top: 10%;
    }

    .headP {
        font-size: 44px;
        margin-top: 3vw;
        height: 8vw;
        /*line-height: 8vw;*/
        background-size: auto 100%;
        background-repeat: no-repeat;
        position: relative;

        .img {
            float: left;
            width: 7vw;
            height: 7vw;
            overflow: hidden;
            border-radius: 50%;
            background-color: rgba(12, 12, 13, 1);

            img {
                width: 100%;
            }
        }

        .name {
            padding-left: 3vw;
            float: left;
            font-family: PingFangMedium;
            text-align: left;

            span {

            }

            span.zh {
                display: block;
                font-weight: bolder;
                font-size: 60px;
                background: linear-gradient(180deg, #FFFFFF 0%, #CAC9C9 200%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            span.en {
                display: block;
                font-size: 30px;
                background: linear-gradient(180deg, rgba(255, 255, 255, .6) 0%, rgba(202, 201, 201, .6) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }

        .position{
            float: left;
            margin-left: 2vw;
            margin-top: 1.5vw;
            font-size: 24px;
            padding-left: .5vw;
            padding-right: .5vw;
            background: #42A5F5;
            border-left: 4px solid #55168A;
            border-top: 4px solid #55168A;
            border-bottom: 4px solid #55168A;
            position: relative;
            /*box-sizing: border-box;*/
            i {
                height: 2vw;
                line-height: 2vw;
                font-style: normal;
            }
            img {
                position: absolute;
                right: -0.9vw;
                top: -4px;
                height: calc(100% + 8px);
            }
        }

        .playerMsg {
            position: absolute;
            right: -7vw;
            top: 3vw;
            margin-left: 2vw;
            text-align: left;
            margin-top: 1.5vw;

            .star {
                background-image: url("../assets/img/playerImg/bg1.svg");
                background-size: 100% 100%;
                padding-right: 5vw;
                padding-left: 1vw;
                height: 2.5vw;
                line-height: 2.5vw;
                width: 16vw;
                display: inline-block;
                font-size: 26px;
                font-family: PingFangMedium;
                color: rgba(255, 255, 255, .8);
            }

        }

    }


</style>
